import { useEffect, useState } from "react";
import { Bell, CloudHail, CloudFog, Snowflake, CloudSnow, CloudRain, Wind } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { http, getDeviceId } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export const ALERT_META = {
  hail: { label: "Dolu riski", icon: CloudHail, color: "#EC4899" },
  fog: { label: "Yoğun sis", icon: CloudFog, color: "#CBD5E1" },
  ice: { label: "Buzlanma riski", icon: Snowflake, color: "#67E8F9" },
  snow: { label: "Kar yağışı", icon: CloudSnow, color: "#BAE6FD" },
  heavy_rain: { label: "Kuvvetli yağış", icon: CloudRain, color: "#3B82F6" },
  wind: { label: "Kuvvetli rüzgar", icon: Wind, color: "#F97316" },
};

export const AlertsBell = ({ favorites, onPick }) => {
  const { t } = useI18n();
  const [alerts, setAlerts] = useState([]);
  const favKey = favorites.map((f) => f.id).join(",");

  useEffect(() => {
    if (!favKey) { setAlerts([]); return; }
    const load = () => http.get("/alerts", { params: { device_id: getDeviceId() } }).then((r) => setAlerts(r.data)).catch(() => {});
    load();
    const id = setInterval(load, 15 * 60 * 1000);
    window.addEventListener("alert-prefs-changed", load);
    return () => { clearInterval(id); window.removeEventListener("alert-prefs-changed", load); };
  }, [favKey]);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="alerts-bell-btn" className="relative shrink-0 rounded-full p-2 text-slate-300 transition-colors hover:bg-white/10" title={t("Uyarılar")}>
          <Bell size={18} />
          {alerts.length > 0 && (
            <span data-testid="alerts-count" className="keep-white absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-600 px-1 font-mono text-[9px] font-bold text-white">{alerts.length}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent data-testid="alerts-popover" align="end" className="glass z-[1300] w-80 border-white/10 p-0 text-slate-100">
        <div className="border-b border-white/5 px-4 py-3 font-heading text-lg font-bold uppercase text-white">{t("Uyarılar")}</div>
        <div className="max-h-80 overflow-y-auto p-2">
          {alerts.length === 0 && (
            <div className="p-3 text-xs text-slate-400">{favorites.length ? t("Favori konumlarınızda önümüzdeki 12 saatte uyarı yok.") : t("Uyarı almak için favori konum ekleyin.")}</div>
          )}
          {alerts.map((a, i) => {
            const m = ALERT_META[a.type];
            return (
              <button key={i} data-testid={`alert-item-${i}`} onClick={() => onPick({ name: a.name, lat: a.lat, lon: a.lon })}
                className="flex w-full items-center gap-3 rounded-lg px-2 py-2 text-left hover:bg-white/5">
                <m.icon size={18} style={{ color: m.color }} />
                <div className="flex-1">
                  <div className="text-sm font-semibold text-slate-100">{a.name}</div>
                  <div className="text-xs" style={{ color: m.color }}>{t(m.label)}</div>
                </div>
                <span className="font-mono text-[11px] text-slate-400">{a.time.slice(11, 16)}</span>
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
};
